import React, { useEffect, useRef, useState } from "react";
import Button from "../..//Elements/Button/Button.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import useScrollTrigger from "../../../hooks/useScrollTrigger.js";
import bytesToDisplayHelper from "../../../utils/bytesToDisplayHelper.js";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";
import GetTransformedDate from "../../../utils/dateViewTransformer.tsx";
import useMailSender from "../../../hooks/useMailSender.js";
import Image from "../../Elements/Image/Image.tsx";
import { decode } from "html-entities";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { DaysLeft } from "../../Reusable/DaysLeft/DaysLeft.js";

const TooltipComponent = () => {
  const { getMailMetaData, getMailStatus } = useMail();
  const { getTextByKey, getHtmlByKey } = useContent();
  const [animationState, setAnimationState] = useState(false);
  const size = bytesToDisplayHelper(getMailMetaData().TotalSize);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationState((prev) => !prev);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const savedCondition =
    getMailMetaData().IsSaved ||
    (getMailStatus() !== "removed" && getMailMetaData().DownloadsCount > 50) ||
    !getMailMetaData().Expiration;

  return (
    <div className="scroll-to-bottom-tooltip-container">
      <div className="scroll-to-bottom-tooltip-text">
        <div className="tooltip-with-padding">
          <span className="bold-text">
            {getMailStatus() === "removed"
              ? getHtmlByKey("mail-expired-button-message")
              : getTextByKey("scroll-to-bottom")}
          </span>
          <div className="animated-text">
            <AnimationContainer
              animationOn={savedCondition || animationState}
              animationClassName="fade-in-long"
              timeout={1000}
            >
              <div className="flex-row dark-grey-text">
                {`${getMailMetaData().filesCount} ${getTextByKey("files")} (${
                  size.size + size.type
                })`}
              </div>
            </AnimationContainer>
            {savedCondition ? null : getMailStatus() === "removed" ? (
              <AnimationContainer
                animationOn={!animationState}
                animationClassName="fade-in-long"
                timeout={1000}
              >
                <div className="flex-row ">
                  {getTextByKey("expiry-date")}:{" "}
                  <GetTransformedDate
                    date={
                      getMailMetaData().RemovalDate
                        ? getMailMetaData().RemovalDate
                        : getMailMetaData().Expiration
                    }
                  />
                </div>
              </AnimationContainer>
            ) : (
              <AnimationContainer
                animationOn={!animationState}
                animationClassName="fade-in-long"
                timeout={1000}
              >
                <div className="flex-row ">
                  <DaysLeft />
                </div>
              </AnimationContainer>
            )}
          </div>
        </div>
      </div>
      <div className="tooltip-arrow"></div>
    </div>
  );
};

const GalleryScrollButton = ({ children, contentRef, ...props }) => {
  const { moreThanNumber } = useScrollTrigger(window.innerHeight / 3.5);

  const { isMailSender, isMailSenderSubscribed } = useMailSender();
  const { getBlackFridayTime, getIsBlackFriday, getTextByKey } = useContent();
  const { getSender, getMailMetaData } = useMail();

  const timeOut = useRef();
  const handleClick = (e) => {
    const toPos = contentRef.current.offsetTop;
    window.scrollTo(0, toPos);
    timeOut.current = setTimeout(() => {
      document.querySelector(".show-transparent-header") &&
        document
          .querySelector(".show-transparent-header")
          .classList.remove("show-transparent-header");
    }, 300);
  };

  useEffect(() => {
    clearTimeout(timeOut.current);
    return () => clearTimeout(timeOut.current);
  }, []);

  const userBrandedHeaderAvatar = getSender()
    ? getSender().brandedHeader && (isMailSenderSubscribed || isMailSender())
      ? getSender().brandedHeader.Avatar
      : null
    : null;

  return (
    <div
      className={`scroll-to-bottom-component ${
        moreThanNumber ? "scrolled-down" : ""
      }`}
      {...props}
    >
      <TooltipComponent />
      <Button
        onClick={handleClick}
        medium
        className={`ripple-effect gray-opacity scroll-to-bottom-button ${
          userBrandedHeaderAvatar ? "with-user-branded-avatar" : ""
        } ${
          getBlackFridayTime() && getIsBlackFriday()
            ? "black-friday-background-color"
            : ""
        }`}
        style={{
          backgroundImage: `url('${userBrandedHeaderAvatar}')`,
          backgroundColor: `${userBrandedHeaderAvatar ? "white" : ""}`,
        }}
        aria-label={getTextByKey("scroll-to-bottom")}
      >
        {userBrandedHeaderAvatar ? null : getBlackFridayTime() &&
          getIsBlackFriday() ? (
          <>
            <Image
              name="black-friday/Black_Friday"
              ext="svg"
              className="black-friday-text"
            />
            <Image
              name="black-friday/alabel_no_shadow"
              ext="svg"
              className="black-friday-sale"
            />
          </>
        ) : (
          <Icon
            name={"jumbomail-logo-small"}
            xxl
            clickable
            white
            title="JUMBOmail"
            alt="JUMBOmail"
          />
        )}
      </Button>
      <div className="button-scroll-mail-text">
        <div className="mail-subject-text">
          <span className={isMailSender() ? "" : "full-width"}>
            {getMailMetaData().subjectText &&
            getMailMetaData().DisplayEmailSubject
              ? decode(getMailMetaData().subjectText)
              : ""}
          </span>
        </div>
        {getMailMetaData().DisplaySenderName ? (
          <div className="mail-sender-text">{getSender().name}</div>
        ) : null}
      </div>
    </div>
  );
};
export default GalleryScrollButton;
